import { useEffect, useRef } from "react";

export const useInputDelay = (
  onSearch: () => any,
  inputValueArray: any[],
  timing = 700
) => {
  const timesRun = useRef(0);

  useEffect(() => {
    const delay = setTimeout(() => {
      timesRun.current++;
      if (timesRun.current > 1) onSearch();
    }, timing);
    return () => clearTimeout(delay);
  }, inputValueArray);
};
